import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { Subscription } from 'rxjs';
import { FileNamePipe } from 'src/app/pipes/attachments/file-name.pipe';
import { CustomButtonComponent } from '../custom-components/custom-button/custom-button.component';

@Component({
  selector: 'app-custom-attach-files',
  templateUrl: './custom-attach-files.component.html',
  styleUrls: ['./custom-attach-files.component.scss'],
  standalone: true,
  imports: [CustomButtonComponent, FileNamePipe, CommonModule]
})
export class CustomAttachFilesComponent implements OnInit {

  disabled: boolean = false;
  fileName: string = "";
  filePath: SafeUrl = "";
  labelConsecutive: number = 0;
  listFiles: any[] = [];
  suscription: Subscription;

  constructor(public config: DynamicDialogConfig,
    private sanitizer: DomSanitizer,) { }

  ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }

    this.suscription = input$?.subscribe((inputs: any) => {
      this.listFiles = inputs.listFiles;
      this.labelConsecutive = inputs.labelConsecutive;
      this.disabled = inputs.disabled;
    });

  }

  attach(id: string) {
    document.getElementById(id)?.click();
  }

  deleteFile(path: any) {
    const file = path.replace(/^.*[\\/]/, '');
    const output$ = this.config.data?.output$;
    output$?.next({ type: 'deleteFile', payload: file });
  }

  downloadFile(path: any) {
    this.filePath = this.sanitizeImageUrl(path);
    // Extrae solo el nombre del archivo desde una ruta completa (elimina los directorios (// windows - \ linux))
    this.fileName = path.replace(/^.*[\\/]/, '');
    const output$ = this.config.data?.output$;
    output$?.next({ type: 'downloadFile', payload: this.fileName });
  }

  sizeFile(size: number) {
    // Convertir bytes a megabytes (1 MB = 1024 * 1024 bytes)
    const sizeMB = size / (1024 * 1024);

    // Redondear el tamaño a dos decimales
    return Math.round(sizeMB * 100) / 100;
  }

  sanitizeImageUrl(imageUrl: string): SafeUrl {
    return this.sanitizer.bypassSecurityTrustUrl(imageUrl);
  }

  async uploadFile(event: any) {
    const file = event.target.files[0];
    if (file != null) {
      const originalName = file.name;
      const extension = originalName.substring(originalName.lastIndexOf('.') + 1);
      let nameWithoutExt = originalName.substring(0, originalName.lastIndexOf('.'));

      //Quitar acentos y la ñ
      nameWithoutExt = nameWithoutExt
        .normalize('NFD') // separa acentos
        .replace(/[\u0300-\u036f]/g, '') // elimina marcas de acento
        .replace(/ñ/gi, 'n');

      //Reemplazar caracteres no alfanuméricos por _
      nameWithoutExt = nameWithoutExt.replace(/[^a-zA-Z0-9]/g, '_');

      //Evitar múltiples guiones bajos seguidos
      nameWithoutExt = nameWithoutExt.replace(/_+/g, '_');

      //Eliminar _ al inicio o al final
      nameWithoutExt = nameWithoutExt.replace(/^_+|_+$/g, '');

      // Reconstruir nombre final con extensión
      const sanitizedFileName = `${nameWithoutExt}.${extension}`;

      const cleanFile = new File([file], sanitizedFileName, { type: file.type });
      const formData = new FormData();
      formData.append('files', cleanFile);

      const output$ = this.config.data?.output$;
      output$?.next({ type: 'uploadFile', payload: formData });
    }

  }
}
